import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  CheckBoxWrapper,
  CheckboxContainer,
  HiddenCheckbox,
  StyledCheckbox,
  ChildrenContainer,
  Icon,
} from './styles';

class CheckboxView extends Component {
  constructor(props) {
    super(props);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.state = {
      checked: props.checked,
    };
  }

  handleCheckboxChange() {
    this.props.onChange(!this.state.checked);
    this.setState({
      checked: !this.state.checked,
    });
  }

  render() {
    const {
      children,
      className,
      checked: propsChecked,
      controlled,
      onChange,
      small,
      ...props
    } = this.props;

    const { checked: stateChecked } = this.state;
    const checked = controlled ? propsChecked : stateChecked;
    const onChangeHandler = controlled ? onChange : this.handleCheckboxChange;

    return (
      <CheckBoxWrapper className={className}>
        <CheckboxContainer>
          <HiddenCheckbox checked={checked} {...props} onChange={onChangeHandler} />
          <StyledCheckbox checked={checked} small={small}>
            <Icon className="fa fa-check" aria-hidden="true" />
          </StyledCheckbox>
        </CheckboxContainer>
        <ChildrenContainer>{children}</ChildrenContainer>
      </CheckBoxWrapper>
    );
  }
}

CheckboxView.defaultProps = {
  checked: false,
  controlled: false,
  className: null,
  onChange: () => {},
  small: false,
};

CheckboxView.propTypes = {
  checked: PropTypes.bool,
  controlled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func,
  className: PropTypes.string,
  small: PropTypes.bool,
};

export default CheckboxView;
